import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

import { EmployeesService, UserService } from '@app/core';

import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { loadMessages, locale } from 'devextreme/localization';
import * as enMessages from 'devextreme/localization/messages/en.json';
import * as frMessages from 'devextreme/localization/messages/fr.json';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly _destroying$ = new Subject<void>();
    private _unsubscriber$: Subject<boolean> = new Subject();
    public isIframe = false;

    constructor(
        @Inject(MSAL_GUARD_CONFIG) public msalGuardConfig: MsalGuardConfiguration,
        private authService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
        private userService: UserService,
        private translate: TranslateService,
        private employeesService: EmployeesService) {

        loadMessages(enMessages);
        loadMessages(frMessages);

        // Setup translation service

        // Select available and fallback langs
        this.translate.addLangs(['en', 'fr']);
        this.translate.setDefaultLang('en');

        // Save language changes
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.userService.language = event.lang;
        });

        // Select the language based on user preference or browser
        const userLang = this.userService.language;
        const browserLang = this.translate.getBrowserLang();

        if (userLang) {
            this.translate.use(userLang);
            locale(userLang);
        }
        else if (browserLang.match(/en|fr/)) {
            this.translate.use(browserLang);
            locale(browserLang);
        }
        else {
            this.translate.use('en');
            locale('en');
        }

    }

    ngOnInit() {
        this.isIframe = window !== window.parent && !window.opener;

        this.msalBroadcastService.msalSubject$
            .pipe(
                filter(
                    (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
                ),
                takeUntil(this._destroying$)
            );

        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                takeUntil(this._destroying$)
            );
    }

    ngOnDestroy() {
        this._unsubscriber$.next(false);
        this._unsubscriber$.complete();
    }


    public login() {
        this.authService.loginPopup()
            .subscribe({ error: (error) => console.log(error) });
    }
}
